"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _convertStyle.default;
  }
});

var _convertStyle = _interopRequireDefault(require("./convertStyle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-div-100vh/lib/convertStyle/index.js
// module id = 346
// module chunks = 0